module.exports = __webpack_public_path__ + "static/hoem-logo-a28df467d79ad145754620007f5ecb7f.png";